import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  flex-direction: column;
  height: var(--chat-height);
  padding: var(--chat-padding);
  border: var(--chat-border);
  border-radius: var(--chat-border-radius);
  background-color: var(--chat-background);
}
`;
export default styles;
